var ConfigDetail = (function () {
    function ConfigDetail() {
    }
    return ConfigDetail;
}());
var Config = (function () {
    function Config() {
    }
    Config.getEnvironmentVariable = function (value) {
        var environment;
        var data;
        environment = window.location.hostname;
        switch (environment) {
            case 'localhost':
                data = {
                    apiBaseUrl: 'http://localhost:4000',
                    graphEndpoint: '/graph',
                    mixpanel_api: "6d24dc504ca8ffdfaef2ccf1df147c4e",
                    algolia_app: 'I6Z96DNER7',
                    algolia_key: '7334284d12ba3a8678b3f540a3bbe9e4',
                    auth0ClientID: '2IS-KX9Fyn1UjiJLF-0RSG1ZTfa78XxG',
                    auth0Domain: 'premiertech-digital-dev.auth0.com',
                    releaseFlags: {
                        'AlgoliaSearch': true,
                        'Auth0Login': false,
                        'file_item': true,
                        'file_po': true,
                        'item_brand': true,
                        'promo': false
                    },
                    algoliaIndex: "RDL_Part_Index"
                };
                break;
            case 'd1kq7ag5sid9fu.cloudfront.net':
            case 'uptimedv.ptchronos.com':
                data = {
                    apiBaseUrl: 'https://uptimeapidv.ptchronos.com',
                    graphEndpoint: '/graph',
                    mixpanel_api: "6d24dc504ca8ffdfaef2ccf1df147c4e",
                    algolia_app: 'I6Z96DNER7',
                    algolia_key: '7334284d12ba3a8678b3f540a3bbe9e4',
                    auth0ClientID: '2IS-KX9Fyn1UjiJLF-0RSG1ZTfa78XxG',
                    auth0Domain: 'premiertech-digital-dev.auth0.com',
                    releaseFlags: {
                        'AlgoliaSearch': true,
                        'Auth0Login': false,
                        'file_item': true,
                        'file_po': true,
                        'item_brand': true,
                        'promo': false
                    },
                    algoliaIndex: "RDL_Part_Index"
                };
                break;
            case 'd1erss51bf6zac.cloudfront.net':
            case 'uptimepp.ptchronos.com':
                data = {
                    //apiBaseUrl: 'https://ur0itcxpwk.execute-api.us-east-1.amazonaws.com/Backend',
                    apiBaseUrl: 'https://uptimeapipp.ptchronos.com',
                    graphEndpoint: '/graph',
                    mixpanel_api: "e068b4539ca06324359ecb0b6507f0d6",
                    algolia_app: 'I6Z96DNER7',
                    algolia_key: '7334284d12ba3a8678b3f540a3bbe9e4',
                    auth0ClientID: '2IS-KX9Fyn1UjiJLF-0RSG1ZTfa78XxG',
                    auth0Domain: 'premiertech-digital-dev.auth0.com',
                    releaseFlags: {
                        'AlgoliaSearch': true,
                        'Auth0Login': false,
                        'file_item': true,
                        'file_po': true,
                        'item_brand': true,
                        'promo': false
                    },
                    algoliaIndex: "RDL_Part_Index"
                };
                break;
            case 'd3injkk1pm7gwj.cloudfront.net':
            case 'uptime.ptchronos.com':
                data = {
                    //apiBaseUrl: 'https://4llq2yp2o2.execute-api.us-east-1.amazonaws.com/Backend',
                    apiBaseUrl: 'https://uptimeapi.ptchronos.com',
                    graphEndpoint: '/graph',
                    mixpanel_api: "4d0695090faf9bc2b84c3fa487f77b42",
                    algolia_app: 'I6Z96DNER7',
                    algolia_key: '7334284d12ba3a8678b3f540a3bbe9e4',
                    auth0ClientID: 'sb8Waw04Wsos724yCQCAoU3A8dF0UFQc',
                    auth0Domain: 'premiertech-digital.auth0.com',
                    releaseFlags: {
                        'AlgoliaSearch': true,
                        'Auth0Login': false,
                        'file_item': true,
                        'file_po': true,
                        'item_brand': true,
                        'promo': false
                    },
                    algoliaIndex: "RDL_Part_Index"
                };
                break;
        }
        return data[value];
    };
    return Config;
}());
export { Config };
;
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/config/config.js
// module id = 128
// module chunks = 0